var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}]},[_c('router-view')],1),_c('Footer'),_c('div',{staticClass:"eu_info"},[_c('img',{attrs:{"alt":"eu_info","src":require("@/assets/images/eu_info.png"),"width":"300"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }